import React from "react";
import Navigation from "./Navbar";
import HeroHomePage from "./HeroHomePage";
import Footer from "./Footer";
import Wedo from "./Wedo";
import Policyweek from "./Policyweek";
import Slider from "./Slider";

const Main = () => {
  return (
    <div className="relative w-full min-h-screen overflow-x-hidden">
      {/* ================= FIXED NAVBAR ================= */}
       {/* <div className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
        <Slider/>
      </div> */}
      <div className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
        {/* <Slider/> */}
        <Navigation />
      </div>

      {/* ================= PAGE CONTENT ================= */}
      <div className="lg:pt-[140px] pt-[80px]"> {/* Padding for fixed navbar */}
        <HeroHomePage />
        <Wedo />
        <Policyweek />
        <Footer />
      </div>
    </div>
  );
};

export default Main;